import { addLibs } from './base'
import './lazy-base'
import * as oidc from './oidc'
import * as mui from './material-ui'
import * as reactstrap from 'reactstrap'
import * as TokenManager from '@sparky/token-manager'
import versions from './versions'

export default addLibs({
  ...oidc,
  ...mui,
  reactstrap,
  TokenManager,
  versions,
})
